import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { DetailsDrawer } from "./DetailDrawer";

//新 monitoring
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailsDrawer />
        </>
    )
}